import { BaseEntity } from '../../models';
import { FormaPagamento } from '../forma-pagamento';
import { condicaoPagamentoAtiva } from './condicao-pagamento-situacao';
import { CondicaoPagamentoPrazo } from './prazo';

export class CondicaoPagamento implements BaseEntity {
    readonly id: number;
    idEmpresa: number;
    nome: string;
    situacao: number;
    tipo: number;
    idFormaPagamento: number;
    formaPagamento: FormaPagamento;
    prazos: CondicaoPagamentoPrazo[];
    prazoMedio: number;
    quantidadeParcelas: number;
    multiplo: number;
    prazoInicial: number;
    percCustoFinanceiro: number;

    // Integração ERP
    codigoIntegracaoErp: number;
    idIntegracaoErp: number;
    integradoErp: boolean;
    integracaoErpSistema: number;
    dataIntegracaoErp: Date;
    dataUltimaIntegracaoErp: Date;

    constructor() {
        this.situacao = condicaoPagamentoAtiva.id;
        this.prazoMedio = 0;
        this.prazos = [];
    }
}
